// @ts-strict-ignore
import * as React from 'react';
import produce from 'immer';
import { useTranslation } from 'common/i18n/hooks';
import { withStyles } from 'common/util/react';
import { CollapsibleTheme, SectionReact } from 'common/components/section';
import { BookmarkYAxisOptions } from 'common/report/insights/util/types';
import { ChartType, InsightsBookmarkParams } from 'common/types/reports/bookmark';
import { BookmarkType } from 'common/report/queries/app-api/bookmark-client';
import { Theme } from 'common/report/queries/app-api/themes';
import { isChartCustomizationEnabled } from 'common/query-builder/chart-customization/utils';
import { useCurrentProject } from 'common/contexts/react/current-project-context';
import { ChartAxisCustomization } from './axis/index';
import css from './index.module.styl?inline';
import styles from './index.module.styl';
import { ChartThemePicker } from './colors';
import { ChartCustomizationUpdate, ChartCustomizationUpdateType } from './axis/types';
type ChartCustomizationPanelParams = {
  bookmarkParams: InsightsBookmarkParams;
  bookmarkType: BookmarkType;
  onUpdate: (updateType: ChartCustomizationUpdateType, update: Partial<ChartCustomizationUpdate>, diffSetting?: Partial<BookmarkYAxisOptions>, oldSetting?: BookmarkYAxisOptions) => void;
  onUpdateTheme: (bookmarkParams: InsightsBookmarkParams) => void;
};
const unsupportedAxisTypes = [ChartType.Bar, ChartType.StackedBar, ChartType.Pie, ChartType.Table, ChartType.Metric];
export function ChartCustomizationPanel(props: ChartCustomizationPanelParams) {
  const {
    t
  } = useTranslation();
  const currentProject = useCurrentProject();
  const bookmarkTheme = props.bookmarkParams.displayOptions.theme;
  const bookmarkThemeId = bookmarkTheme === null || bookmarkTheme === void 0 ? void 0 : bookmarkTheme.id;
  const bookmarkCustomTheme = bookmarkTheme as Theme !== null && bookmarkTheme as Theme !== void 0 && (bookmarkTheme as Theme).data ? bookmarkTheme as Theme : null;
  const handleThemeSelect = (theme: Theme | null) => {
    const params = produce(props.bookmarkParams, draftParams => {
      draftParams.displayOptions.theme = theme !== null && theme !== void 0 && theme.id ? {
        id: theme.id
      } : theme;
    });
    props.onUpdateTheme(params);
  };
  const supportsChartCustomization = props.bookmarkType !== BookmarkType.Flows && !unsupportedAxisTypes.includes(props.bookmarkParams.displayOptions.chartType);
  return <div className={styles.chartCustomizationPanel} data-sentry-component="ChartCustomizationPanel" data-sentry-source-file="index.tsx">
      {supportsChartCustomization && <SectionReact className={styles.section} headerTitle={t("chart-customization.axis")} theme={CollapsibleTheme.INLINE}>
          <ChartAxisCustomization bookmarkParams={props.bookmarkParams} onUpdate={props.onUpdate} />
        </SectionReact>}
      {isChartCustomizationEnabled(currentProject.get().value) && <SectionReact elref='themesSection' className={styles.section} headerTitle={t("chart-customization.themes")} theme={CollapsibleTheme.INLINE}>
          <ChartThemePicker allowCreate onThemeSelect={handleThemeSelect} customTheme={bookmarkCustomTheme} activeThemeId={bookmarkThemeId} />
        </SectionReact>}
    </div>;
}
export const ChartCustomizationPanelReact = withStyles(ChartCustomizationPanel, css);